import { INITIAL_STATE, setProfile } from '../core'
import {
    RECEIVE_PROFILE_V2,
} from '../action_creators'

function profile(state=INITIAL_STATE.profile, action) {
    switch (action.type) {
        case RECEIVE_PROFILE_V2:
            return setProfile(state, action.profile)
        default:
            return state
    }
}

export default profile



// WEBPACK FOOTER //
// ./src/redux/reducers/profile_reducer.js